/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type RatingStarSvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function RatingStarSvgIcon(props: RatingStarSvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 17 16"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M7.466.557a1 1 0 0 1 1.793 0l1.81 3.667a1 1 0 0 0 .753.547l4.046.588a1 1 0 0 1 .554 1.706l-2.927 2.854a1 1 0 0 0-.288.885l.691 4.03a1 1 0 0 1-1.45 1.054l-3.62-1.903a1 1 0 0 0-.93 0l-3.62 1.903a1 1 0 0 1-1.45-1.054l.69-4.03a1 1 0 0 0-.287-.885L.303 7.065a1 1 0 0 1 .554-1.706l4.047-.588a1 1 0 0 0 .752-.547z"
        }
      ></path>
    </svg>
  );
}

export default RatingStarSvgIcon;
/* prettier-ignore-end */
